import { render, staticRenderFns } from "./sell-contract-details.html?vue&type=template&id=2ab99055&scoped=true&"
import script from "./sell-contract-details.ts?vue&type=script&lang=js&"
export * from "./sell-contract-details.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab99055",
  null
  
)

export default component.exports